export default {
  // confirm info/warning
  confirm_Info_Warning: 0,

  // confirm yes_no
  confirm_Yes_No: 1,

  // confirm yes_no_cancel
  confirm_Yes_No_Cancel: 2,

  // confirm delete
  confirm_Delete: 3,

  // confirm Đóng
  confirm_Close: 4,

  // Chỉ nhận thông báo là text
  confirmOnlyTextForm: 12,

  //Xác nhận tự động hạch toán đồng thời
  confirmAutoGenerateParallel: 10,

  // Xác nhận đã phát sinh dữ liệu
  confirmIncurredData: 20,

  //Xác nhận cập nhật hạch toán khi có chênh lệch
  confirmGenerateParallel: 21,

  // confirm yes_no_custom
  confirm_Yes_No_Custom: 25,

  /**
   * Hướng dẫn quyết toán nhanh
   */
  quick_help_settlement: 26,

  /**
   * Xem chi thiết thông tin người dùng
   */
  view_user_info_detail: 27,

  showIncurredDataWarning: 8,

  showConfirmValidate: 5,

  showConfirmValidateCustom: 6,
  showConfirmWithDontShowAgain: 7,
  showChooseOptionConfirm: 9,
  showChooseOptionConfirmVertical: 18
};
